import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import lifeQuoteJson from '../../life-config/lifeQuotesConfig.json';
import apiUrlPoint from '../../life-config/apiEndPoints.json';
import productConfig from '../../life-config/productCodeConfig.json';
// import { data }'../../../configuration/config.json';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { SharedApiService } from '../../services/shared-api.service';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.css']
})
export class StepperComponent implements OnInit {

  /**
   * Defining variable before constructor initalizes
   */

    lifeQuoteConfigList: any = lifeQuoteJson.editModalInitialJson;
    apiUrl: object = apiUrlPoint.apiEndPoints;
    productConf = productConfig.product_type;
    uuid: string;
    proposalId: string;
    stepRes: any;
    personalDetails : boolean;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private sharedData: SharedApiService,
  ) {

    /**
     * Extarcting UUID and proposal id
     */

    this.activatedRoute.params.subscribe(params => {
        this.uuid = params['uuid'];
        this.proposalId = params['proposalId'];
    });

  }

  /**
   * setting image on successful boolean completion
   * enabling and displaying value  on completion
   * Routing  on successful completion
   */


  isPersonalDetailsCmpleted() {

    if ( this.stepRes['personal_details']) {

        this.personalDetails = true;
        //stepper.next();
        this.router.navigate(['/life/proposal/communication-details', this.proposalId, this.uuid]);

    }

  }

  ngOnInit() {

    /**
     * If Proposal ID and UUID
     */

    if (this.uuid && this.proposalId) {


        this.apiService.getPropsalInfo ( this.apiUrl['apiV2LifeProposal'] , this.proposalId, this.uuid , this.apiUrl['statusStepper'] );


        this.apiService.getPropsalInfo(
            this.apiUrl['apiV2LifeProposal'],
            this.proposalId, this.uuid ,
            this.apiUrl['statusStepper']
            ).subscribe(res => {

                this.stepRes = res['response'];

                if(this.stepRes){
                    //this.feedStepRes();
                }
                
                console.log('stepper response is ', this.stepRes );
        },
            err => {
                console.log('sonething went at our end', err);
            });
    }

  }

}
